import _objectWithoutProperties from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { getBlockHighlightPosition } from 'components/common/RichTextEditor/util/block';
import { Highlight, HighlightContainer, HighlightFooter, HighlightHeader, HighlightIcon } from './HighlightWrapper.style';

var HighlightWrapper = function HighlightWrapper(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var block = props.block,
      editorState = props.blockProps.editorState;
  var highlightPosition = getBlockHighlightPosition(editorState, block);

  if (!highlightPosition) {
    return __jsx(React.Fragment, null, children);
  }

  var isFirst = highlightPosition.isFirst,
      isLast = highlightPosition.isLast;
  return __jsx(React.Fragment, null, isFirst && __jsx(HighlightHeader, {
    contentEditable: false
  }, __jsx(HighlightIcon, null), __jsx(FormattedMessage, {
    id: "highlightWrapper.title"
  })), __jsx(HighlightContainer, null, __jsx(Highlight, {
    isFirst: isFirst,
    isLast: isLast
  }, children)), isLast && __jsx(HighlightFooter, null));
};

export default HighlightWrapper;